/*
 * Early-offer landing-page card.
 *
 * The selector inside it is the shared snippets/ryedical-offer.liquid (its
 * controller is assets/ryedical-offer.js). This element only swaps the
 * product image to match the selected supply and purchase method, using the
 * `ryedical:purchase-change` event the selector dispatches.
 */
class RyedicalEarlyOffer extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.addEventListener('ryedical:purchase-change', (event) => {
      const { supply, method } = event.detail ?? {};
      if (supply) this.updateMedia(supply, method === 'subscription' ? 'subscription' : 'one-time');
    });
  }

  updateMedia(supply, method) {
    const images = [...this.querySelectorAll('[data-eo-media-key]')];
    if (!images.length) return;
    let match = images.find((image) => image.dataset.eoMediaKey === `${supply}-${method}`);
    match ||= images.find((image) => image.dataset.eoMediaKey === `${supply}-one-time`);
    match ||= images[0];
    images.forEach((image) => { image.hidden = image !== match; });
  }
}

if (!customElements.get('ryedical-early-offer')) {
  customElements.define('ryedical-early-offer', RyedicalEarlyOffer);
}
